import GridRef from '../gridRef'
import util from '../gridutil'
import ko from 'knockout'
var Airamixin = function (params) {
  this.focusedRow = ko.observable(0)
  this.focusedCol = ko.observable(0)
  this.gridRef = new GridRef()
  this.isValidCell = (row, col) => {
    return (
      !isNaN(row) &&
      !isNaN(col) &&
      row >= 0 &&
      col >= 0 &&
      this.rows &&
      this.rows.peek().length &&
      row < this.rows.peek().length &&
      col < ko.utils.unwrapObservable(this.columns).length
    )
  }
  // 获取下一个单元格
  this.getNextCell = (curRow, curCol, directionX, directionY) => {
    var row = curRow + directionY
    var col = curCol + directionX
    var rowCount = this.rows().length
    var isLeftRight = directionX !== 0

    if (!rowCount) {
      return false
    }

    var colCount = this.columns().length

    if (isLeftRight) {
      if (col < 0) {
        col = colCount - 1
        row--
      }

      if (col >= colCount) {
        col = 0
        row++
      }
    }

    if (!isLeftRight) {
      if (row < 0) {
        col--
        row = rowCount - 1
        if (col >= 0 && !this.gridRef.get(row, col)) {
          // Sometimes the bottom row is not completely filled in. In this case,
          // jump to the next filled in cell.
          row--
        }
      } else if (row >= rowCount || !this.gridRef.get(row, col)) {
        row = 0
        col++
      }
    }
    if (this.isValidCell(row, col)) {
      return {
        row: row,
        col: col
      }
    } else if (this.isValidCell(curRow, curCol)) {
      return {
        row: curRow,
        col: curCol
      }
    } else {
      return false
    }
  }
  this.isEditable = col => {
    var column = ko.utils.unwrapObservable(this.columns)[col]
    if (column && column.aria) {
      return !!column.aria
    } else {
      return false
    }
  }
  // 获取下一个可编辑的单元格
  this.getNextEditableCell = function (directionX, directionY) {
    var nextCell = this.getNextCell(
      this.focusedRow(),
      this.focusedCol(),
      directionX,
      directionY
    )
    while (!this.isEditable(nextCell.col)) {
      var currRow = nextCell.row
      var currCol = nextCell.col

      nextCell = this.getNextCell(currRow, currCol, directionX, directionY)

      if (currRow === nextCell.row && currCol === nextCell.col) {
        // There are no more cells to try if getNextCell returns the current cell
        return false
      }
    }
    return nextCell
  }
  this.setFocus = (row, col) => {
    var lastInstance = this.gridRef.get(this.focusedRow(), this.focusedCol())
    if (lastInstance && lastInstance.setUnFoucs) {
      lastInstance.setUnFoucs()
    }
    this.focusedRow(row)
    this.focusedCol(col)
    var instance = this.gridRef.get(row, col)
    if (instance) {
      if (instance.setFocus) {
        instance.setFocus()
      } else {
        console.warn('td component should implements the "setFoucs" function')
      }
    }
  }
  this.onBodyClick = (vm, evt) => {
    if (this.aria) {
      var elTd = util.findClosest(evt.target, '[aria-colindex]')
      var elRow = elTd.parentNode
      var focusIndex = {
        col: +elTd.attributes['aria-colindex'].value,
        row: +elRow.attributes['aria-rowindex'].value
      }
      this.focusedRow(focusIndex.row)
      this.focusedCol(focusIndex.col)
    }
    return true
  }

  this.onBodyKeyDown = (vm, event) => {
    if (this.aria) {
      var key = event.which || event.keyCode
      var rowCaret = this.focusedRow()
      var colCaret = this.focusedCol()
      var nextCell

      switch (key) {
        case util.Aria.KeyCode.UP:
          nextCell = this.getNextEditableCell(0, -1)
          rowCaret = nextCell.row
          colCaret = nextCell.col
          this.setFocus(rowCaret, colCaret)
          break
        case util.Aria.KeyCode.DOWN:
          nextCell = this.getNextEditableCell(0, 1)
          rowCaret = nextCell.row
          colCaret = nextCell.col
          this.setFocus(rowCaret, colCaret)
          break
        case util.Aria.KeyCode.LEFT:
          nextCell = this.getNextEditableCell(-1, 0)
          rowCaret = nextCell.row
          colCaret = nextCell.col
          this.setFocus(rowCaret, colCaret)
          break
        case util.Aria.KeyCode.RIGHT:
          nextCell = this.getNextEditableCell(1, 0)
          rowCaret = nextCell.row
          colCaret = nextCell.col
          this.setFocus(rowCaret, colCaret)
          break
        case util.Aria.KeyCode.HOME:
          if (event.ctrlKey) {
            rowCaret = 0
          }
          colCaret = 0
          this.setFocus(rowCaret, colCaret)
          break
        case util.Aria.KeyCode.END:
          if (event.ctrlKey) {
            rowCaret = this.rows().length - 1
          }
          colCaret = ko.utils.unwrapObservable(this.columns).length - 1
          this.setFocus(rowCaret, colCaret)
          break
        case util.Aria.KeyCode.TAB:
          nextCell = this.getNextEditableCell(1, 0)
          rowCaret = nextCell.row
          colCaret = nextCell.col
          this.setFocus(rowCaret, colCaret)
          return false
        default:
      }
    }
    return true
  }
}
export default Airamixin



// WEBPACK FOOTER //
// ./src/components/grid/mixin/ariamixin.js